import React from 'react';
type Tome = {
  number: string;
  title: string;
  range: string;
  promise: string;
  badge: string;
  badgeText: string;
  flag?: string;
  contents: string[];
};
const tomes: Tome[] = [{
  number: '01',
  title: 'Finding the Voice',
  range: 'Confidence & First Words · WS-01–07',
  promise: 'Lower the fear, get every voice heard and land the first micro-talks.',
  badge: 'bg-amber',
  badgeText: 'text-ink',
  flag: 'Start here',
  contents: ['The Safe-to-Speak Setup: five moves that kill the fear', 'The 4-Minute Warm-Up Ladder: breath, face, voice, body', 'The 30-Second Circle: everyone talks on day one', 'The 3-second pause that replaces “um”']
}, {
  number: '02',
  title: 'Thinking on Your Feet',
  range: 'Impromptu Speaking · WS-08–14',
  promise: 'Get anyone answering on the spot — with zero prep for you or them.',
  badge: 'bg-coral',
  badgeText: 'text-white',
  flag: 'Club favourite',
  contents: ['The 3-Breath Reset and the P.O.P. Frame', 'The Topic Engine: 5 dials that spin endless prompts', '180 prompts ready to read aloud', 'Table Rounds, Rapid Fire, the Expert Hot Seat and relays']
}, {
  number: '03',
  title: 'Building the Talk',
  range: 'Structure & Storytelling · WS-15–21',
  promise: 'Turn “a talk about X” into a talk with a spine, a hook and a story that sticks.',
  badge: 'bg-teal',
  badgeText: 'text-white',
  contents: ['The Spine: one message, three supports, one ask', 'Hook-Point-Land: openings and closes that land', 'Story in Four Beats: You, Trouble, Turn, Point', 'Build-a-Talk Workshop: a full short talk in one session']
}, {
  number: '04',
  title: 'Owning the Room',
  range: 'Voice, Body & Presence · WS-22–28',
  promise: 'Delivery that holds attention — and nerves turned into energy.',
  badge: 'bg-indigo',
  badgeText: 'text-white',
  contents: ['Pace-Pause-Punch: the three vocal tools', 'The Presence Triangle: Voice, Body, Eyes', 'Hands Problem, Solved and Use the Space', 'The Nerve-to-Energy Switch and Blank-Mind Rescue']
}, {
  number: '05',
  title: 'Moving People',
  range: 'Persuasion, Debate & Q&A · WS-29–35',
  promise: 'Persuade without manipulating, argue with evidence and handle any question.',
  badge: 'bg-coral',
  badgeText: 'text-white',
  contents: ['The Bridge: head, heart and trust', 'Claim-Evidence-So-What: the argument unit', 'Mini-Debate, Four-Corner Debate, Rapid Rebuttal', 'The Q&A Shield: Pause, Reframe, Answer, Bridge']
}, {
  number: '06',
  title: 'Showtime',
  range: 'Presentations, Pitches & Events · WS-36–42',
  promise: 'Slides, pitches, toasts and showcase nights — plus a way to measure the year.',
  badge: 'bg-amber',
  badgeText: 'text-ink',
  contents: ['The 5-Slide Talk and The Pitch Ladder', 'The Occasion Frame: toasts, intros, tributes', 'The Run-Sheet: host a showcase without chaos', 'Progress Rubric + a fill-in 52-week calendar']
}];
const everyVolume = ['Every session on one open-and-run page', '7 printable worksheets per volume (42 in the pack)', 'The Session Formula for 5, 10–12 and 20+ minute slots', 'Grab-and-go index, 3-level guide and a one-page field card'];
export function Tomes() {
  return <section aria-labelledby="tomes-heading" className="w-full bg-white text-ink" data-id="element-398" data-mp="dxtx1wp9cdx4">
      <div className="max-w-6xl mx-auto px-5 py-16 sm:py-20" data-id="element-399" data-mp="ivlpqsxq842d">
        <div className="text-center" data-id="element-400" data-mp="mw5kjputuvlc">
          <p className="text-[11px] font-semibold uppercase tracking-[1.6px] text-teal-deep" data-id="element-401" data-mp="mv4bts1aal6s">Your whole year</p>
          <h2 id="tomes-heading" className="mt-3 font-display text-3xl font-extrabold text-ink sm:text-5xl" data-id="element-402" data-mp="rop0gtgzm2tb">
            Inside the pack — six volumes
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-slate" data-id="element-403" data-mp="3vbflgumzdurj">
            The arc every speaker follows, from first words to a real stage. Run
            them in order across the year, or open the volume your group needs
            this week — each one stands on its own.
          </p>
        </div>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-404" data-mp="3lygs54ofe31n">
          {tomes.map(tome => <article key={tome.number} className={`flex flex-col rounded-2xl border bg-white p-6 shadow-soft ${tome.flag === 'Start here' ? 'border-coral ring-1 ring-coral' : 'border-cloud-dark'}`} data-id="element-405" data-mp="3h5dyyxnk8vlz">
              <div className="flex items-center gap-2.5" data-id="element-406" data-mp="8rezvn5aku49">
                <span className={`flex h-9 w-9 items-center justify-center rounded-full font-display text-base font-extrabold ${tome.badge} ${tome.badgeText}`} data-id="element-407" data-mp="8ost3pq86in3">
                  {tome.number}
                </span>
                <span className="text-[11px] font-semibold uppercase tracking-widest text-slate" data-id="element-408" data-mp="25jp04sv6yxsv">Volume {tome.number}</span>
                {tome.flag && <span className={`ml-auto rounded-full px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider ${tome.flag === 'Start here' ? 'bg-coral text-white' : 'bg-amber-soft text-amber-deep'}`} data-id="element-409" data-mp="l26bs8vgz1ge">
                    {tome.flag}
                  </span>}
              </div>
              <h3 className="mt-3 font-display text-xl font-extrabold leading-tight tracking-tight text-ink" data-id="element-410" data-mp="2a3pagw5cqy8">{tome.title}</h3>
              <p className="mt-1 text-[11px] font-semibold uppercase tracking-widest text-coral-deep" data-id="element-411" data-mp="6adye2f8jxhb">{tome.range}</p>
              <p className="mt-2 text-sm text-slate" data-id="element-412" data-mp="3th6l5lmxjles">{tome.promise}</p>
              <ul className="mt-4 grid gap-2 border-t border-cloud-dark pt-4" data-id="element-413" data-mp="3thgb597z5skh">
                {tome.contents.map(item => <li key={item} className="flex gap-2 text-[13px] text-ink" data-id="element-414" data-mp="1rptdwpxhp1fk">
                    <span className={`mt-[7px] h-1.5 w-1.5 flex-none rounded-full ${tome.badge}`} data-id="element-415" data-mp="1rnqq8cjt7ke0" />
                    {item}
                  </li>)}
              </ul>
            </article>)}
        </div>

        <div className="mt-6 rounded-2xl bg-ink px-5 py-5 text-white sm:px-7" data-id="element-416" data-mp="1g9yjbotb9wjt">
          <p className="text-[11px] font-semibold uppercase tracking-widest text-amber" data-id="element-417" data-mp="1bbew7l2zeepv">In every volume</p>
          <ul className="mt-3 grid gap-2 sm:grid-cols-2 lg:grid-cols-4" data-id="element-418" data-mp="28z5pn9z0bqfm">
            {everyVolume.map(item => <li key={item} className="flex gap-2 text-[13px] text-white/85" data-id="element-419" data-mp="23zj66isl5dyd">
                <span className="mt-[7px] h-1.5 w-1.5 flex-none rounded-full bg-teal" data-id="element-420" data-mp="1z9ceub6ovfcf" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}